import {
  OrientationType,
  ScreenOrientation,
} from '@capawesome/capacitor-screen-orientation';
import { isPlatform } from '@ionic/react';
import { useEffect } from 'react';

export const useLockOrientation = (orientation?: OrientationType): void => {
  useEffect(() => {
    if (!isPlatform('capacitor')) {
      return;
    }

    try {
      if (orientation) {
        ScreenOrientation.lock({ type: orientation });
      } else {
        ScreenOrientation.unlock();
      }
    } catch (_error) {
      // .. do nothing on this error
    }

    return () => {
      try {
        ScreenOrientation.unlock();
      } catch (_error) {
        // .. do nothing on this error
      }
    };
  }, [orientation]);
};

export const useLockMobileOrientation = (): void => {
  let orientation: OrientationType | undefined = undefined;
  if (isPlatform('mobile') && !isPlatform('tablet')) {
    orientation = OrientationType.PORTRAIT;
  }

  useLockOrientation(orientation);
};
